import { AppSetting } from '@klubovna/api-client';

export interface AppSettingsState {
  settings: AppSetting[];
  loading: boolean;
  error: string | null;
}

export const initialAppSettingsState: AppSettingsState = {
  settings: [],
  loading: false,
  error: null,
};
